import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

export default function SecondCard({ ...props }) {
  const { subtitle, total, subtitle2, total2, button1, button2, avatar } = props;

  return (
    <Card
      sx={{
        boxShadow:
          "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset;",
        borderRadius: 2,
      }}
    >
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Typography variant="h1" gutterBottom>
              {total}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {subtitle}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h1" gutterBottom>
              {total2}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {subtitle2}
            </Typography>
          </Grid>
          <Grid
            item
            xs={2}
            >
              {button1}
            </Grid>
          <Grid
            item
            xs={2}
            >
              {button2}
            </Grid>
          <Grid
            item
            xs={2}
            md={2}
            sx={{ textAlign: "-webkit-right", alignContent: "center" }}
          >
            <Avatar
              alt="Anon"
              sx={{ width: 45, height: 45, backgroundColor: "#FAFAFA" }}
            >
              {avatar}
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
